import React from "react";

import Navbar from "./hp3ddesign_components/Navbar";
import HeroSection from "./hp3ddesign_components/HeroSection";
import ProblemSection from "./hp3ddesign_components/ProblemSection";
import ControlSection from "./hp3ddesign_components/ControlSection";
import SolutionSection from "./hp3ddesign_components/SolutionSection";
import BeforeAfterSection from "./hp3ddesign_components/BeforeAfterSection";
import VisionSection from "./hp3ddesign_components/VisionSection";
import CTASection from "./hp3ddesign_components/CTASection";
import Footer from "./hp3ddesign_components/Footer";

import StoryCanvas from "./hp3ddesign_components/scene/StoryCanvas";
import ScrollController from "./hp3ddesign_components/scene/ScrollController";
import SceneController from "./hp3ddesign_components/scene/SceneController";
import ScrollProgress from "./hp3ddesign_components/ScrollProgress";

import "./HP3dDesign.css";

const HP3dDesign = () => {
    return (
        <div id="landing-root">
            <SceneController>
                <div className="tw-relative tw-bg-[#050816] tw-text-white tw-overflow-x-hidden">
                    {/* Handles scroll events and triggers scene animations based on viewport position */}
                    <ScrollController />

                    {/* Scene-specific canvas rendering for the storytelling visuals */}
                    <StoryCanvas />

                    {/* Progress bar component that reflects scroll position through the storytelling sections */}
                    <ScrollProgress />

                    {/*
                        Customised navigational bar only for this storytelling/experience page.
                        Keeps global navigation links while allowing page-specific styling
                        and state (e.g., highlight active section during scroll).
                    */}
                    <Navbar />

                    <main className="tw-relative tw-z-10">
                        {/* 1. Grab attention */}
                        <HeroSection />

                        {/* 2. Show their daily struggle */}
                        <ProblemSection />

                        {/* 3. Build trust */}
                        <ControlSection />

                        {/* 4. Reveal SiraFinOps */}
                        <SolutionSection />

                        {/* 5. Compare transformation */}
                        <BeforeAfterSection />

                        {/* 6. Show the bigger vision */}
                        <VisionSection />

                        {/* 7. Convert */}
                        <CTASection />

                        {/* 8. Footer and additional site information */}
                        <Footer />
                    </main>
                </div>
            </SceneController>
        </div>
    );
};

export default HP3dDesign;
